// extracted by mini-css-extract-plugin
module.exports = {"rules_title":"rules_rules_title__3s7sf","rules":"rules_rules__d0U5s","link":"rules_link__1IiCr","number_rules":"rules_number_rules__3LYrV","list_rules":"rules_list_rules__35i_o"};